<!-- 只对日期进行操作的统一控件-->
<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="info.title" width="500px" append-to-body @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="150px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="info.label">
            <el-date-picker
              v-model="changeDate"
              type="date"
              style="width:251px;"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="confirm">{{ $t('FinanceManage.Confirm') }}</el-button>
      <el-button size="mini" @click="cancel">{{ $t('Message.Cancel') }}</el-button>
    </div>

    <!--加入费用-->
    <join-charge-dialog
      v-if="showJoinChargeDialog.show"
      :visible.sync="showJoinChargeDialog.show"
      search-item-module="2201"
      :default-conditions="showJoinChargeDialog.addChargeCondition"
      @addChargeCallBackEvent="addChargeCallBackEvent"
      @leavePage="cancel"
    />
  </el-dialog>
</template>

<script>

import { Assert } from '@/utils/validate'
import moment from 'moment'
import joinChargeDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/joinChargeDialog'
import {
  saveFunc
} from '@/api/act/preliminaryEstimate'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'SelectDateDialog',
  components: { joinChargeDialog },
  props: {
    applicationStatus: { type: Number, required: true }, // 应收应付
    showPageDate: { type: Boolean, required: false }, // 是否使用上次选中时间
    pageDate: { type: Date, required: false },
    visible: { type: Boolean, required: true },
    disabledAfterToday: { type: Boolean, default: true }, // 大于今天的日期禁止选择
    info: { type: Object, default: () => {
      return { title: '', label: '' }
    } }
  },
  data() {
    return {
      confirmCallbackFunc: null,
      innerVisible: this.visible,
      changeDate: moment(new Date()).format('YYYY-MM-DD'),
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      SystemConstants,
      showJoinChargeDialog: {
        show: false,
        selectDate: null,
        addChargeCondition: { // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          hasBillPayment: -1,
          isShowWriteOff: -1,
          hasBilling: -1,
          isAr: 0
        }
      }
    }
  },
  computed: {
  },
  watch: {
    accountDate() {

    }
  },
  created() {
    if (this.showPageDate) {
      this.changeDate = moment(new Date(this.pageDate)).format('YYYY-MM-DD')
    }
  },
  methods: {
    // 加入费用回调函数
    addChargeCallBackEvent() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        accountReceivable: this.applicationStatus,
        financialMonth: new Date(this.showJoinChargeDialog.selectDate)
      }
      saveFunc(params).then(res => {
        if (res.data === 'ok') {
          this.$message.success(this.$t('Message.SaveSuccessfully'))
          this.query()
        } else if (res.data === 'asyncDo') {
          this.$message.success(ColumnUtils.showTypeLabelFunc(res.data, SystemConstants.ASYNC_MAPPING_TYPE))
        } else {
          this.$message.warning(ColumnUtils.showTypeLabelFunc(res.data, SystemConstants.ERROR_MAPPING_TYPE))
        }
      })
    },
    disabledDate(currDate) {
      if (this.disabledAfterToday) {
        const d = moment(currDate, 'YYYY-MM_DD')
        return d > new Date()
      }
      return false
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    async confirm() {
      await Assert.isNotBlank(this.changeDate, this.$t('Message.PleaseSelect') + `${this.info.title}` + this.$t('Message.Cargo_Date'), 'warning')
      this.selectDateConfirm(this.changeDate)
    },
    selectDateConfirm(date) {
      this.showJoinChargeDialog.addChargeCondition.isAr = this.applicationStatus
      if (this.applicationStatus) {
        // 应收需要未开票的
        this.showJoinChargeDialog.addChargeCondition.hasInvoice = 0
      } else {
        // 应付需要未核销的
        this.showJoinChargeDialog.addChargeCondition.isShowWriteOff = 0
      }
      this.showJoinChargeDialog.addChargeCondition.advance = 0
      this.showJoinChargeDialog.selectDate = date
      this.showJoinChargeDialog.show = true
    }
  }
}
</script>

<style lang="scss">
</style>
